import { Component, Input } from '@angular/core';

import { Friend } from '@app/home/friends/friends.model';
import { DividerComponent } from '@app/shared/components/divider/divider.component';
import { FriendsItemComponent } from '@app/home/friends/friends-item/friends-item.component';

@Component({
  selector: 'slotcom-friends-list',
  templateUrl: './friends-list.component.html',
  styleUrls: ['./friends-list.component.scss'],
  standalone: true,
  imports: [DividerComponent, FriendsItemComponent],
})
export class FriendsListComponent {
  @Input() friends: Friend[];
}
